import * as React from 'react';
import { ProductCard as Card, LoadingProductCard as LoadingCard } from 'webapp/shared/ProductCard';
import { ListType } from 'webapp/tracking/events/items';

export type ProductCardPropType = {
  list_id?: string;
  list_name?: string;
  list_type?: ListType;
  list_pagination_index?: number;
  list_pagination_max?: number;
  product: NordicNest.Api.PartialProductApiModel & { accessoryToSku?: string };
  index?: number;
  hideBorder?: boolean;
};

export const ProductCard = React.memo((props: ProductCardPropType) => {
  return <Card {...props} />;
});

export function LoadingProductCard() {
  return <LoadingCard />;
}
